<div class="admin-time-picker" [class.is-open]="isOpen">
  <button
    type="button"
    class="yt-time-trigger"
    [disabled]="disabled"
    (click)="openPicker($event)"
  >
    <i nz-icon nzType="field-time"></i>
    <span [class.placeholder]="!displayValue">
      {{ displayValue || placeholder }}
    </span>
    @if (allowClear && value) {
      <button
        type="button"
        class="clear-button"
        aria-label="Clear selected time"
        (click)="clear($event)"
      >
        x
      </button>
    }
  </button>

  @if (isOpen) {
    <div class="yt-time-popover" (click)="$event.stopPropagation()">
      <div class="time-panel">
        <div class="panel-heading">
          <div>
            <small>Select time</small>
            <strong>{{ displayValue || '00:00' }}</strong>
          </div>
        </div>

        <div class="time-display">
          <div class="time-highlight" aria-hidden="true"></div>
          <div
            class="time-scroll-column"
            aria-label="Select hour"
            (scroll)="onTimeColumnScroll($event, 'hour')"
          >
            @for (hour of hourOptions; track hour.value) {
              <button
                type="button"
                class="time-scroll-option"
                [attr.data-value]="hour.value"
                [class.selected]="hour.value === draftValue.getHours()"
                (click)="setHour(hour.value)"
              >
                {{ hour.label }}
              </button>
            }
          </div>
          <span class="time-separator">:</span>
          <div
            class="time-scroll-column"
            aria-label="Select minute"
            (scroll)="onTimeColumnScroll($event, 'minute')"
          >
            @for (minute of minuteOptions; track minute.value) {
              <button
                type="button"
                class="time-scroll-option"
                [attr.data-value]="minute.value"
                [class.selected]="minute.value === draftValue.getMinutes()"
                (click)="setMinute(minute.value)"
              >
                {{ minute.label }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
